import { Box } from '@mui/material'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

interface DateProps {
  date: string
  // params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  onClick?: (params: GridRenderCellParams) => void
}

export default function DateCell({ date, params, densityStyles, onClick }: DateProps): React.ReactElement {
  const _orgId = params?.row?.org_uuid
  const isParent = params?.row?.isParent
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
        cursor: isParent ? 'default' : 'pointer',
      }}
      onClick={() => onClick?.(params)}
    >
      {isParent ? date ?? null : '–'}
    </Box>
  )
}
